// TODO use this operators enum for build gql filters across the app
// so we can use it in the ConditionInput for operators instead of string
export enum ConditionOperator {
  Equals = '=',
  DoesNotEqual = '!=',
  Empty = 'is_empty',
  NotEmpty = 'is_not_empty',
  Contains = 'ilike',
  DoesNotContain = 'not_ilike',
  LessThan = '<',
  GreaterThan = '>',
  LessOrEqThan = '<=',
  GreaterOrEqThan = '>=',
  Between = 'between',
  NotBetween = 'not_between',
  LessOrEqThanOrNull = 'less_or_equal_or_null',
  LessThanOrNull = 'less_than_or_null',
  In = 'in',
  NotIn = 'not_in',
  IsOneOf = 'is_one_of',
  IsNotOneOf = 'is_not_one_of',
  DateEquals = 'date_equals',
  DateDoesNotEqual = 'date_does_not_equal',
  DateIsAfter = 'date_is_after',
  DateIsBefore = 'date_is_before',
  DateLessOrEqualThan = 'date_less_or_equal_then',
  DateGreaterOrEqualThan = 'date_greater_or_equal_then',
}

export interface ConditionInput {
  attribute: string;
  operator: string;
  logicalOperator?: string;
  value: string | boolean;
  // custom attribute default the db layer coalesces unset values to, so a filter matches the cell
  coalesceDefault?: string;
}

export interface SortingInput {
  attribute: string;
  desc?: boolean;
  aggFunction?: string;
  // custom attribute default the db layer coalesces unset values to, so sort matches the cell
  coalesceDefault?: string;
}

export interface SearchInput {
  searchTerm: string;
  targetIdAttributes: string[];
}

export interface Records<T> {
  records: T[];
  metadata?: {
    limit?: number;
    offset?: number;
    totalRecords?: number;
    appVersion?: string;
    forceAppVersion?: string;
  };
}

export type DeepPartial<T> = {
  [P in keyof T]?: DeepPartial<T[P]>;
};

export type NullableDeepPartial<T> = {
  [P in keyof T]?: NullableDeepPartial<T[P]> | null;
};

export type Id = string | number;

export type QueryParams = {
  filters?: ConditionInput[];
  sorting?: SortingInput | SortingInput[];
  limit?: number;
  offset?: number;
  searchParams?: SearchInput;
  includeDeleted?: boolean;
};

export interface QueryVariables {
  params?: QueryParams;
  skipTotalRecords?: boolean;
}

export enum EntityNames {
  Conversation = 'conversation',
  Client = 'client',
  Site = 'site',
  Project = 'project',
  PlatformUser = 'platformUser',
}

export type WithTypeName<T> = T & { __typename: string };

export type WithId<T> = T & { id: string };
